import React, { useEffect, useState } from "react";
import {
    Delete as DeleteIcon,
    Add as AddIcon,
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import { useMemo } from "react";
import redirectService from "../../../services/redirect.service";
import { useErrorHandler } from "../../../hooks";

const defaultKeys = [
    {
        title: "نام",
        field: "name",
        active: true,
    },
];

export default function RedirectPage() {

    const errorHandler = useErrorHandler();

    const [data, setData] = useState([]);
    const deleteItem = async (item) => {
        const res = await redirectService.deleteRedirect(item.id);
        if(res.error){
            const error = res.error.response.data.error;
            errorHandler(error);
        }
    };

    const headerCells = useMemo(
        () => [
            {
                field: "url",
                title: "آدرس",
                mainField: true,
            },
            {
                field: "redirect",
                title: "مقصد",
                mainField: false,
            },
        ],
        []
    );

    useEffect(() => {
        onRefresh();
    }, []);

    const onRefresh = async () => {
        const { data, error } = await redirectService.getRedirects();
        if (error) {
            return;
        }

        setData(data);
    };

    return (
        <div className="p-3">
            <DataTable
                headCells={headerCells}
                data={data}
                onRefresh={onRefresh}
                rowActions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <DeleteIcon />,
                        modalContent: (props) => (
                            <ConfirmModalContent
                                onConfirm={() => deleteItem(props.data)}
                                confirmText={props.data.name}
                                close={props.close}
                            />
                        ),
                    },
                ]}
                actions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <AddIcon />,
                        tooltip: "ایجاد Redirect",
                        modalContent: (props) => <FormModalContent {...props} />,
                    },
                ]}
                searchKeys={defaultKeys}
                title="Redirect"
            />
        </div>
    );
}
